<div class="d-flex">
  <app-profile-display
    class="pe-2"
    [person]="folder.created_user"
    [borderColor]="'#EAEAED'"
    [size]="size"
  ></app-profile-display>
  @if (folder.permission_unit_count) {
    <div class="border-start ps-2">
      <app-multiple-profile-display
        [size]="size"
        [count]="folder.permission_unit_count"
        [showingDisplay]="shareWithDisplayCount"
        [displayList]="folder.permission_display"
      ></app-multiple-profile-display>
    </div>
  }
</div>
